import { GET_SUBSCRIPTION_USERS } from "../../../helper/url_helper";
import { axiosApi } from "../../../services/api";

import { createAsyncThunk } from "@reduxjs/toolkit";



export const getAllSubscriptionUsers = createAsyncThunk(
  "subscription/getAllSubscriptionUsers",
  async (request, { rejectWithValue }) => {
    try {
      const res = await axiosApi.get(GET_SUBSCRIPTION_USERS, {
        params: request,
      });

      const purchases = res?.data?.data?.purchases || [];
      const pagination = res?.data?.data?.pagination || {};

      return {
        rows: purchases,
        count: pagination.total,
      };
    } catch (err) {
      return rejectWithValue({
        error: err?.response?.data?.error,
        statusCode: err.response?.status || 500,
      });
    }
  }
);

